import Skeleton from "react-loading-skeleton";

const PropertyPageSkeleton = () => {
  return (
    <div className="wrapper h-auto py-10">
      <div className="first grid-container">
        <div className="first flex flex-col gap-5">
          <Skeleton
            className="w-full h-[400px]"
            containerClassName="w-full h-[400px]"
          />
          <Skeleton count={4} className="w-full h-[200px]" />
        </div>
        <div className="second">
          <Skeleton
            containerClassName="flex flex-col"
            className="w-full h-[200px]"
            count={6}
          />
        </div>
      </div>
    </div>
  );
};
export default PropertyPageSkeleton;
